module.exports = __webpack_public_path__ + "img/two.1630993415105.png";